const AdError = () => {

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 15, color: "#fff", alignItems: "center", }}>
            <p>Something went wrong, please try again later</p>
        </div>
    )
}

export default AdError